import {memo} from "react";
import {numberFormat} from "~/utils";
import {Image} from "~/components";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Bảng xếp hạng Top nhân viên theo doanh thu cho Dashboard CEO.
 * Dữ liệu: dashboardApi.ceoTopPerformers() = [{ firstname, lastname, username, avatar, revenue }].
 */
const MEDALS = {
	0: {bg: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)', ring: '#fde68a', color: '#fff'},
	1: {bg: 'linear-gradient(135deg, #94a3b8 0%, #cbd5e1 100%)', ring: '#e2e8f0', color: '#fff'},
	2: {bg: 'linear-gradient(135deg, #b45309 0%, #d97706 100%)', ring: '#fcd9a8', color: '#fff'},
};

function TopPerformersWidget({
	items = [],
	loading = false,
	title = 'Top doanh thu',
	icon = 'fa-light fa-trophy',
	gradient = 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
}) {

	const max = items.reduce((m, it) => Math.max(m, it.revenue || it.total || 0), 0) || 1;

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(124,58,237,0.14)', background: '#fff'}}>
			<DashboardWidgetHeader icon={icon} title={title} gradient={gradient} />

			<div style={{padding: '14px 18px'}}>
				{loading && (
					<div style={{textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13}}>Đang tải...</div>
				)}

				{!loading && items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon={icon} style={{fontSize: 26, display: 'block', marginBottom: 6}} />
						<span style={{fontSize: 12}}>Chưa có dữ liệu doanh thu</span>
					</div>
				)}

				{!loading && items.map((item, index) => {
					const value  = item.revenue ?? item.total ?? 0;
					const name   = item.firstname ? `${item.firstname} ${item.lastname}` : `#${item.id}`;
					const width  = Math.max(4, Math.round(value / max * 100));
					const medal  = MEDALS[index];
					const isLast = index === items.length - 1;

					return (
						<div key={`top-${item.id}-${index}`} style={{
							display: 'flex', gap: 12, alignItems: 'center',
							paddingBottom: isLast ? 0 : 14, marginBottom: isLast ? 0 : 14,
							borderBottom: isLast ? 'none' : '1px dashed #eef2f7',
						}}>
							{/* Hạng */}
							<div style={{
								width: 28, height: 28, flexShrink: 0, borderRadius: '50%',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								fontSize: 13, fontWeight: 800,
								background: medal ? medal.bg : '#f1f5f9',
								color: medal ? medal.color : '#94a3b8',
								boxShadow: medal ? `0 0 0 3px ${medal.ring}` : 'none',
							}}>
								{medal ? <FontAwesomeIcon icon="fa-solid fa-crown" style={{color: '#fff', fontSize: 12}} /> : index + 1}
							</div>

							{/* Avatar */}
							<div className="avatar" style={{width: 42, height: 42, flexShrink: 0}}><Image src={item.avatar} /></div>

							{/* Tên + thanh tiến độ */}
							<div style={{flex: 1, minWidth: 0}}>
								<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8}}>
									<b style={{fontSize: 13, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{name}</b>
									<b style={{fontSize: 13, color: '#7c3aed', flexShrink: 0}}>{numberFormat(value)}</b>
								</div>
								<div style={{height: 6, borderRadius: 6, background: '#f1f5f9', overflow: 'hidden', marginTop: 5}}>
									<div style={{
										width: `${width}%`, height: '100%', borderRadius: 6,
										background: medal ? medal.bg : 'linear-gradient(135deg, #a78bfa 0%, #c4b5fd 100%)',
									}} />
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(TopPerformersWidget);
